import React, { useState } from 'react';
import { Activity, AlertTriangle, TrendingUp, Users } from 'lucide-react';
import DateRangeSelector from './components/DateRangeSelector';
import PulseCheckView from './PulseCheckView';
import '../../styles/BIDashboard.css';

import HealthErrorsView from './HealthErrorsView';
import EngagementView from './EngagementView';
import GrowthRetentionView from './GrowthRetentionView';

const VIEWS = [
  { key: 'pulse', label: 'Pulse Check', icon: Activity },
  { key: 'health', label: 'Health & Errors', icon: AlertTriangle },
  { key: 'engagement', label: 'Engagement', icon: TrendingUp },
  { key: 'growth', label: 'Growth & Retention', icon: Users },
];

const BIDashboard = () => {
  const [activeView, setActiveView] = useState('pulse');
  const [dateRange, setDateRange] = useState('-30d');

  const renderView = () => {
    switch (activeView) {
      case 'pulse':
        return <PulseCheckView dateRange={dateRange} />;
      case 'health':
        return <HealthErrorsView dateRange={dateRange} />;
      case 'engagement':
        return <EngagementView dateRange={dateRange} />;
      case 'growth':
        return <GrowthRetentionView dateRange={dateRange} />;
      default:
        return <PulseCheckView dateRange={dateRange} />;
    }
  };

  return (
    <div className="bi-dashboard">
      <div className="bi-header">
        <div className="bi-tabs">
          {VIEWS.map((view) => (
            <button
              key={view.key}
              className={`bi-tab ${activeView === view.key ? 'active' : ''}`}
              onClick={() => setActiveView(view.key)}
            >
              <view.icon size={14} />
              {view.label}
            </button>
          ))}
        </div>
        <DateRangeSelector value={dateRange} onChange={setDateRange} />
      </div>
      {renderView()}
    </div>
  );
};

export default BIDashboard;
